export default "__VITE_ASSET__63fa769e__"